import { render, staticRenderFns } from "./KnSupplierCategories.vue?vue&type=template&id=aa8ba1bc"
import script from "./KnSupplierCategories.js?vue&type=script&lang=js&external"
export * from "./KnSupplierCategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports